import React from 'react';
import styles from '../../ChargebackProtection.module.css';
import { CheckIcon, XIcon } from '../../icons';

const covered = [
  'Unauthorized / fraudulent transactions',
  'Eligible "friendly fraud" disputes',
  'Claims where Fyntiq handles the response',
  'Qualifying charges under your agreement',
];

const notCovered = [
  'Refunds you agree to give',
  'Service or quality disputes',
  '"Item not as described" claims',
  'Anything outside the eligibility terms',
];

const Coverage = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }}>
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />Set expectations</span>
        <h2>What&apos;s covered — and what&apos;s not.</h2>
        <p className={styles.secLead}>Chargeback Protection is built for fraud, not for ordinary refunds or service disputes. Here&apos;s the honest breakdown.</p>
      </div>
      <div className={`${styles.coverageGrid} ${styles.sr}`} data-sr>
        <div className={styles.coverageCard}>
          <div className={styles.coverageHeader}>
            <span className={styles.coverageIconGreen}>
              <svg viewBox="0 0 24 24" width="17" fill="none" stroke="#2EB66E" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 L9 17 l-5 -5" />
              </svg>
            </span>
            <span className={styles.coverageTitle}>Covered</span>
          </div>
          <ul className={styles.fList} style={{ gap: 13 }}>
            {covered.map((t) => <li key={t}><CheckIcon />{t}</li>)}
          </ul>
        </div>
        <div className={styles.coverageCard}>
          <div className={styles.coverageHeader}>
            <span className={styles.coverageIconGray}>
              <svg viewBox="0 0 24 24" width="16" fill="none" stroke="#8B8B85" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 6l12 12M18 6 6 18" />
              </svg>
            </span>
            <span className={styles.coverageTitleMuted}>Not covered</span>
          </div>
          <ul className={styles.notCoveredList}>
            {notCovered.map((t) => <li key={t}><XIcon />{t}</li>)}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default Coverage;
